<template>
  <div>
    <FeeCalculator
      :countryCode="selectedCountry.countryCode"
      :amount="amount"
      :src="src"
      :dst="'usdt'"
      @feeCalculated="
        feeHtml => {
          onFeeCalculated(feeHtml)
        }
      "
      @srcAmountCalculated="
        srcAmount => {
          totalToPay = srcAmount
        }
      "
    />
    <PhoneOperatorDetector
      :fullPhoneNumber="`${selectedCountry.phonePrefix}${phoneNumber}`"
      @operatorDetected="
        feeHtml => {
          onOperatorDetected(feeHtml)
        }
      "
    />
    <div v-if="!loading" class="p-6 flex flex-col gap-6">
      <FormComponent
        :key="formKey"
        ref="form"
        class="w-full grid grid-cols-12"
        :fields="formFields"
        @fieldChanged="
          data => {
            onFieldsChanged(data)
          }
        "
        :onFormSubmited="
          data => {
            onOperationDataFilled(data)
          }
        "
        :class="{ shimmerElement: !initiated }"
      >
        <template #submitButton>
          <div class="col-span-12">
            <button class="hidden" type="submit" ref="submit"></button>
            <div class="py-1"></div>
            <div
              class="mx-0 text-white overflow-hidden font-medium relative bg-[#55AD94] bg-opacity-50 p-4 rounded-[1.4rem]"
            >
              <div class="right-0 px-4 absolute top-2">
                <div
                  class="rounded-full bg-white bg-opacity-0 relative w-12 h-12 p-2"
                >
                  <!-- <div
                    class="absolute w-full h-full bg-white scale-[1.9] opacity-10 rounded-full top-0 left-0"
                  ></div> -->
                  <img
                    src="@/assets/images/services/usdtIcon.svg"
                    class="object-contain w-full h-full rotate-[-10deg] rounded-lg"
                  />
                </div>
              </div>
              <div class="relative text-lg">
                {{ $t('transactions.form.youWillReceive') }}

                <span
                  class="text-[#07D79D]"
                  @click="
                    () => {
                      $Commons.copy(convertedAmount, $t('success'))
                    }
                  "
                >
                  {{ convertedAmount }}
                </span>
                USDT
              </div>
            </div>
            <div class="py-1"></div>

            <button
              class="buttonComponent mt-4 arrow w-full"
              @click="$refs.submit.click()"
            >
              {{ totalToPay ? 'Payer ' + totalToPay + ' CFA' : 'Continuer' }}
            </button>
          </div>
        </template>
      </FormComponent>
    </div>
    <div v-else class="flex items-center justify-center w-full py-[60px]">
      <div class="w-[35%]">
        <div class="flex py-5 items-center justify-center w-full h-full">
          <svg
            aria-hidden="true"
            class="w-full h-full text-gray-200 animate-spin fill-primary-500"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import FormComponent from '@/components/utils/FormComponent.vue'
import FeeCalculator from '@/components/transaction/transactionLaunch/FeeCalculator.vue'
import PhoneOperatorDetector from '@/components/transaction/transactionLaunch/PhoneOperatorDetector.vue'
import { getPaymentMethodsOptions } from './getPaymentMethodsOptions'

export default defineComponent({
  name: 'BuyUsdtForm',
  components: {
    FormComponent,
    FeeCalculator,
    PhoneOperatorDetector,
  },
  props: {},
  data() {
    return {
      formFields: [
        {
          type: 'number',
          propertyName: 'amount',
          label: this.$t('transactions.form.amount'),
          inputProps: {
            min: 1,
            max: 10000000000000,
            suffix: 'CFA',
          },
          defaultValue: '1000',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'select',
          propertyName: 'fundingSource',
          options: [],
          formatOptionInputDisplay(option) {
            return `${option.name}`
          },
          formatOptionsDisplay(option) {
            return `${option.name}`
          },
          inputProps: {},
          label: this.$t('transactions.form.howToPay'),
          defaultValue: this.$t('transactions.form.payWithMobileMoney'),
          required: true,
          class: 'col-span-12',
        },

        {
          type: 'select',
          propertyName: 'phoneCountry',
          options: this.$Countries.getSignupCountries(),
          formatOptionInputDisplay(country) {
            return `${country.callingCode}`
          },
          formatOptionsDisplay(country) {
            return `<div class="flex gap-2 justify-between w-full items-center h-[30px]"><span>${
              country.countryName
            }</span><span>+${country.callingCode}</span></div>`
          },
          inputProps: {
            disabled: true,
            selectTitle: 'Séléctionnez un pays',
          },
          label: '',
          defaultValue: ``,
          required: false,
          class: {
            ' [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-lg col-span-3': true,
            hidden: true,
          },

          showFieldIf(filledData, computedFields) {
            return (
              /mobile money/i.test(filledData.fundingSource) ||
              computedFields?.fundingSource?.id == 'momo'
            )
          },
        },

        {
          type: 'number',
          propertyName: 'phoneNumber',
          label: this.$t('transactions.form.phone'),
          defaultValue: '',
          inputProps: {
            minLenght: 6,
            allowTrailingZero: true,
          },
          class: { 'col-span-12': true, 'col-span-9': false },
          showFieldIf(filledData, computedFields) {
            return (
              /mobile money/i.test(filledData.fundingSource) ||
              computedFields?.fundingSource?.id == 'momo'
            )
          },
        },
        {
          type: 'select',
          propertyName: 'accountType',
          options: [
            {
              id: 'trc20',
              name: 'USDT TRC20',
            },
            {
              id: 'erc20',
              name: 'USDT ERC20',
            },
            {
              id: 'bep20',
              name: 'USDT BEP20',
            },
            {
              id: 'binance',
              name: 'Compte Binance',
            },
          ],
          formatOptionInputDisplay(option) {
            return `${option.name}`
          },
          formatOptionsDisplay(option) {
            return `${option.name}`
          },
          inputProps: {},
          label: 'Compte de réception',
          defaultValue: 'USDT TRC20',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'text',
          propertyName: 'usdtAccountId',
          label: this.$t('transactions.form.usdtAccountId'),
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
      ],
      eventsIds: [],
      loading: false,
      formKey: 'initial',
      userData: {},
      addresses: {},
      appInfo: {},
      rates: {},
      amount: 0,
      usdtToXofRate: 0,
      totalToPay: 0,
      src: '',
      dst: '',
      selectedCountry: this.$Countries.find('BJ'),
      phoneNumber: '',
      initiated: false,
      feeDisplay: '',
    }
  },
  async mounted() {
    await this.loadData()
    this.loadDefaultFieldsConfig()
    this.loadSavedTransactionData()
    this.autocompletPhoneStart()
    this.formKey = Date.now()
    this.initiated = true
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async loadData() {
      this.userData = await this.$Events.sendDataRequestResolve('userData')
      this.addresses = await this.$Events.sendDataRequestResolve('addresses')
      this.appInfo = await this.$Events.sendDataRequestResolve('appInfo')
      this.rates = await this.$Events.sendDataRequestResolve('rates')
      console.log(this.appInfo, this.rates)
    },
    field(propertyName) {
      return this.formFields.findIndex(el => el.propertyName == propertyName)
    },
    loadDefaultFieldsConfig() {
      const phoneCountryField = this.formFields[this.field('phoneCountry')]
      const phoneNumberField = this.formFields[this.field('phoneNumber')]
      const fundingSourceField = this.formFields[this.field('fundingSource')]
      const amountField = this.formFields[this.field('amount')]
      const minAmount = this.appInfo?.metaData?.minAmountBuyUsdt
      const fullPhoneNumber = this.userData.phoneNumber

      const phoneNumber = fullPhoneNumber.slice(3)
      const country = this.$Countries.getPhoneCountry(fullPhoneNumber)
      this.selectedCountry = country
      fundingSourceField.options = getPaymentMethodsOptions(
        'buy',
        this.selectedCountry.countryCode,
        this.$t,
      )
      fundingSourceField.defaultValue = fundingSourceField.options[0].name

      let usdtToXofRate = this.rates?.metaData?.buyRates?.USDT[country.currency]
      this.usdtToXofRate = usdtToXofRate
      amountField.label += ` (1 USDT = ${usdtToXofRate} FCFA)`
      amountField.inputProps.min = minAmount || 200
      phoneCountryField.defaultValue = country.phonePrefix
      phoneNumberField.defaultValue = phoneNumber
      phoneNumberField.inputProps.prefix = country.phonePrefix
      phoneNumberField.placeHolder = `Ex: ${country.phoneSample}`
      if (this.userData?.metaData?.isAdmin) {
        phoneCountryField.class.hidden = false
        phoneCountryField.required = true
        phoneCountryField.inputProps.disabled = false
        phoneNumberField.class['col-span-12'] = false
        phoneNumberField.class['col-span-9'] = true
        phoneNumberField.inputProps.prefix = ''
      } else {
        phoneCountryField.class.hidden = true
        phoneCountryField.inputProps.disabled = true
        phoneNumberField.class['col-span-12'] = true
        phoneNumberField.class['col-span-9'] = false
      }
    },
    loadSavedTransactionData() {
      const saved = this.$QuickStorage.getStored('transactionFormData')
      if (!saved) return
      const phoneNumberField = this.formFields[this.field('phoneNumber')]
      const fundingSourceField = this.formFields[this.field('fundingSource')]
      const amountField = this.formFields[this.field('amount')]
      const accountIdField = this.formFields[this.field('usdtAccountId')]

      if (saved.amount) amountField.defaultValue = saved.amount
      if (saved.phoneNumber) phoneNumberField.defaultValue = saved.phoneNumber
      if (saved.usdtAccountId) accountIdField.defaultValue = saved.usdtAccountId
    },

    autocompletPhoneStart() {
      const fullPhoneNumber = this.userData.phoneNumber
      const country = this.$Countries.getPhoneCountry(fullPhoneNumber)

      if (!country) return

      const phoneNumberField = this.formFields[this.field('phoneNumber')]
      const defaultPhone = phoneNumberField.defaultValue

      if (country.countryCode !== 'GA') return
      if (defaultPhone.startsWith(0)) return
      if (defaultPhone.length >= 9) return
      phoneNumberField.defaultValue = `0${defaultPhone}`
    },
    onFieldsChanged(data) {
      this.amount = data.amount
      this.phoneNumber = data.phoneNumber
      if (data.phoneCountry) this.selectedCountry = data.phoneCountry
      this.setAccountIdLabel(data.accountType)
      this.src = data.fundingSource?.id || 'momo'

      if (this.formKey == 'initial') return
      this.$QuickStorage.storeData('transactionFormData', data)
    },
    onFeeCalculated(feeHtml) {
      this.feeDisplay = feeHtml
      this.refreshAmountDetail()
      // this.formFields[this.field('amount')].inputProps.detailText = feeHtml
    },
    onOperatorDetected(feeHtml) {
      this.formFields[this.field('phoneNumber')].inputProps.suffix = feeHtml
    },
    setAccountIdLabel(accountType) {
      const labels = {
        trc20: 'Votre adresse TRC20 ',
        erc20: 'Votre adresse ERC20 ',
        bep20: 'Votre adresse BEP20 ',
        binance: 'Votre adresse Binance ',
      }
      this.formFields[this.field('usdtAccountId')].label =
        labels[accountType.id || 'trc20']
    },
    async onOperationDataFilled(data) {
      const transactionData = {
        ...data,
        usdtAccountId: data.usdtAccountId,
        usdtAmount: this.convertedAmount,
        src: data.fundingSource?.id || 'momo',
        externalWallet: data.fundingSource?.wallet || '',

        accountType: data.accountType?.id || 'trc20',
        dst: 'usdt',
      }
      this.loading = true
      this.$Events.dispatchEvent('launch_transaction_request', transactionData)
      this.$Events.dispatchEvent('start_loading')
    },
    refreshAmountDetail() {
      // this.formFields[this.field('amount')].inputProps.detailText =
      //   `${this.convertedAmount} USDT ${this.feeDisplay}`
      this.formFields[this.field('amount')].inputProps.detailText =
        `<span class="text-sm"> = ${this.convertedAmount} USDT </span> &bull;&nbsp; ${this.feeDisplay}`
    },
  },
  computed: {
    convertedAmount() {
      const usdtToXofRate = this.usdtToXofRate
      const converted = Math.ceil((this.amount / usdtToXofRate) * 100) / 100
      return converted
    },
  },
})
</script>
